export const CAROUSEL_DRAWER_TEST_ID = 'carousel-drawer';
export const CAROUSEL_DRAWER_INNER_TEST_ID = 'carousel-drawer-inner';
